/**
 * Created by senani on 12/19/18.
 */

import React, {Component} from "react";
import "./CartItem.css";
import {FormattedMessage} from "react-intl";
import CartItemDetailsExpandView from "./CartItemDetails/CartItemDetailsExpandView";
import OrderType1ExpandedView from "./CartItemDetails/OrderType1ExpandedView/OrderType1ExpandedView";
import ReactImageZoom from 'react-image-zoom';
import {Link} from "react-router-dom";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import axios from "axios";
import No_Image from '../../../../assets/img/NO_IMAGE.png';

const ImageView = (props) => {
    if (props.reviewResult) {
        const imgProps = {
            "width": 120, "scale": 2.75, "img": props.imagePath, "offset": {"vertical": -150, "horizontal": 10},
            "border": "1px solid #ececec"
        };
        return (
            <div className="cart-item-preview-image">
                <ReactImageZoom className="cart-item-preview-image" {...imgProps}/>
            </div>);
    } else {
        return (
            <div className="cart-item-preview-image">
                <img src={No_Image} width={120} border="1px solid #ececec"/>
            </div>);
    }
};

class CartItem extends Component {

    constructor(props) {
        super(props);
        this.state = {calculatedBuildTime: ''};
        this.cartItemDto = this.cartItemDto.bind();
        this.getGerberReviewResult = this.getGerberReviewResult.bind(this);
    }

    componentDidMount() {
        // console.log('------------------------------params-  ',this.props.itemDetails)
        // console.log('------------------------------params-thickness  ',this.props.itemDetails.quotation.pcbParam.thickness)

        if (this.props.itemDetails.quotation.pcbParam !== null) {
            this.getGerberReviewResult();
            let buildTimeJson = {
                layer: this.props.itemDetails.quotation.pcbParam.layer,
                pcbColor: this.props.itemDetails.quotation.pcbParam.pcbColor,
                qty: this.props.itemDetails.quotation.pcbParam.qty,
                thickness: this.props.itemDetails.quotation.pcbParam.thickness
            };
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            };

            let cartEditResourceUrl = RESOURCE_BASE_URL + 'api/jlcpcb/buildTime';

            axios.post(cartEditResourceUrl, buildTimeJson, axiosConfig)
                .then((res) => {
                    console.log('buildTime-aaa---------------------', res.data)
                    // alert(res.data);
                    this.setState({
                        calculatedBuildTime: res.data
                    })
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                    // alert("error");

                });
        }else{
            this.setState({
                calculatedBuildTime: "5~8日"
            })
        }

    }

    getGerberReviewResult=() => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        let cartResourceUrl = RESOURCE_BASE_URL + 'api/users/' + localStorage.getItem("userId") + '/cart/getReviewResult';

        axios.get(cartResourceUrl, axiosConfig)
            .then(
                (res) => {
                    console.log("[Gerber review] ===> : ", res.data);
                }
            )
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            })

    }

    cartItemDto = (gerberDto_imageUrlTop) => {
        InitialQuotationState.temGerberDto = gerberDto_imageUrlTop;
        InitialQuotationState.temGerberDtoData = this.props.itemDetails.gerberDto;
        localStorage.setItem("igd", gerberDto_imageUrlTop);
        localStorage.setItem("igdto", JSON.stringify(this.props.itemDetails.gerberDto));
    };

    render() {
        const goTo = {
            pathname: '/gerber_viewer',
            imageUrl: this.props.itemDetails.gerberViewerUrl,
            fileUrl: this.props.itemDetails.itemName
        };

        // console.log("ITEM DETAILES DUO ====> ", this.props.itemDetails);
        let buildTime = "";
        return (
            <div className="cart-item-div">
                <div className="pull-left">
                    <ImageView imagePath={this.props.itemDetails.gerberDto.imageUrlTop}
                               reviewResult={this.props.itemDetails.reviewResult}/>
                    <br/>
                    <div className="gerber-view">
                        {/*<Link to={goTo}*/}
                        {/*      onClick={() => this.cartItemDto(this.props.itemDetails.gerberDto.imageUrlTop)}*/}
                        {/*      target="_blank"*/}
                        {/*      className="text-primary cart-row-text-color">*/}
                        {/*    ガーバービューア*/}
                        {/*</Link>*/}
                    </div>

                </div>

                <div className="pull-left cart-item-details">
                    <div className="item-data-div cart-itm-desc-ordr">

                        {this.props.itemDetails.quotation.orderType === 1 &&
                        <b>
                            <FormattedMessage id="app.cart.item.pcb"
                                              defaultMessage="PCB prototype :"
                                              description=""/>
                        </b>
                        }
                        {this.props.itemDetails.quotation.orderType === 2 &&
                        <b>
                            <FormattedMessage id="app.cart.item.both"
                                              defaultMessage="PCB/SMT prototype :"
                                              description=""/>
                        </b>
                        }
                        {this.props.itemDetails.quotation.orderType === 3 &&
                        <b>
                            SMTメタルマスク
                        </b>
                        }
                        &nbsp;<b><p>{this.props.itemDetails.itemName}</p></b>

                    </div>
                    <div className="item-data-div">
                        <small><FormattedMessage id="app.cart.item.gerber-file"
                                                 defaultMessage="Gerber file -"
                                                 description=""/>{this.props.itemDetails.itemName}</small>
                    </div>
                    <div className="item-data-div">
                        <small><FormattedMessage id="app.cart.item.build-time"
                                                 defaultMessage="Build Time - "
                                                 description=""/>
                            {/*{this.props.itemDetails.chargeDetails.buildTime}*/}
                            <text>
                                {this.state.calculatedBuildTime}
                                {/*{*/}
                                {/*this.props.itemDetails.quotation.orderType === 1 || this.props.itemDetails.quotation.orderType === 2 ?*/}
                                {/*(*/}
                                {/*this.props.itemDetails.quotation.pcbParam.layer === 1 ?*/}
                                {/*this.props.itemDetails.quotation.pcbParam.qty <= 10 ?*/}
                                {/*buildTime = "24時間" :*/}
                                {/*this.props.itemDetails.quotation.pcbParam.qty <= 30 ?*/}
                                {/*buildTime = "1-2日" :*/}
                                {/*this.props.itemDetails.quotation.pcbParam.qty <= 50 ?*/}
                                {/*buildTime = "3-4日" :*/}
                                {/*this.props.itemDetails.quotation.pcbParam.qty <= 75 ?*/}
                                {/*buildTime = "4-5日" : buildTime = "4-5日" :*/}
                                {/*this.props.itemDetails.quotation.pcbParam.layer === 2 ?*/}
                                {/*this.props.itemDetails.quotation.pcbParam.qty <= 10 ?*/}
                                {/*buildTime = "24時間" :*/}
                                {/*this.props.itemDetails.quotation.pcbParam.qty <= 30 ?*/}
                                {/*buildTime = "1-2日" :*/}
                                {/*(this.props.itemDetails.quotation.pcbParam.qty >= 50) ?*/}
                                {/*buildTime = "5-6日" : buildTime = "5-6日" :*/}
                                {/*this.props.itemDetails.quotation.pcbParam.layer === 4 ?*/}
                                {/*this.props.itemDetails.quotation.pcbParam.qty <= 50 ?*/}
                                {/*buildTime = "4-5日" : buildTime = "6-8日"*/}
                                {/*: buildTime = "6-8日"*/}
                                {/*) : buildTime = "6-8日"*/}
                                {/*}*/}
                            </text>
                        </small>
                    </div>

                    <div className="expand-link-div">
                        <CartItemDetailsExpandView itemDetails={this.props.itemDetails}/>
                    </div>
                </div>
                {/*<div>ガーバービューア</div>*/}

            </div>
        )
    }
}

export default CartItem;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartItem/CartItem.js